import { ColorPicker } from "@progress/kendo-react-inputs";

const paletteSettings = {
  palette: [
    "#FFFFFF",
    "#F2F2F2",
    "#BFBFBF",
    "#7F7F7F",
    "#000000",

    "#C6E0B4",
    "#A9D08E",
    "#70AD47",
    "#548235",
    "#375623",

    "#BDD7EE",
    "#9DC3E6",
    "#5B9BD5",
    "#2E75B6",
    "#1F4E79",

    "#FFF2CC",
    "#FFF59D",
    "#FFE699",
    "#FFD966",
    "#FFD600",

    "#FFF3E0",
    "#FFE0B2",
    "#FFCC80",
    "#FFA726",
    "#FB8C00",

    "#FFC7CE",
    "#FF7F7F",
    "#FF5050",
    "#FF0000",
    "#C00000",
  ],
  columns: 5,
  tileSize: 30,
};

export const TabTextColorProperty = {
  propertyName: "TabTextColor",
  propertyDisplay: "Tab Text Color",
  propertyType: "string",
  propertyCategory: "Layout",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <ColorPicker
        name={this.propertyName}
        onChange={(e) => {
          handlePropertyChange({
            propName: this.propertyName,
            propValue: e.value,
          });
        }}
        value={currentPropertyValues?.[this.propertyName] || "#000000"}
        disabled={!currentPropertyValues?.IsTab}
        paletteSettings={paletteSettings}
      />
    );
  },
};
